module.exports = __webpack_public_path__ + "static/media/donasi2.337441c0.jpg";